module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/html-loader/dist/cjs.js!../../../node_modules/aurelia-webpack-plugin/dist/html-requires-loader.js!../../../node_modules/aurelia-template-lint-webpack-loader/index.js??ruleSet[1].rules[1].use[0]!./blank-page.html"));
	}, "views/blank-page/blank-page.html");
}